import React from "react";
import { Space, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { Booking } from "../../types/booking";
import {
  getPickupDaysFromToday,
  getPickupDisplayStatus,
  getPickupDay,
} from "../../utils/agentBookingPickupDate";

const { Text } = Typography;

interface AgentPickupDateCellProps {
  booking: Booking;
}

export const AgentPickupDateCell: React.FC<AgentPickupDateCellProps> = ({
  booking,
}) => {
  const pickup = getPickupDay(booking);
  if (!pickup) {
    return <span>-</span>;
  }

  const status = getPickupDisplayStatus(booking);
  const label = pickup.format("MMM D, YYYY");

  if (status === "received") {
    return (
      <Space direction="vertical" size={0}>
        <span>{label}</span>
        <Text type="secondary" style={{ fontSize: 11 }}>
          Received{" "}
          {dayjs(booking.origin_received_date).format("MMM D")}
        </Text>
      </Space>
    );
  }

  if (status === "overdue") {
    const daysLate = Math.abs(getPickupDaysFromToday(booking) ?? 0);
    return (
      <Space direction="vertical" size={0}>
        <Text type="danger">{label}</Text>
        <Tag color="red" style={{ margin: 0, fontSize: 11 }}>
          {daysLate === 0 ? "Due today" : `${daysLate}d overdue`}
        </Tag>
      </Space>
    );
  }

  if (status === "due_today") {
    return (
      <Space direction="vertical" size={0}>
        <Text type="warning">{label}</Text>
        <Tag color="orange" style={{ margin: 0, fontSize: 11 }}>
          Due today
        </Tag>
      </Space>
    );
  }

  if (status === "upcoming") {
    const days = getPickupDaysFromToday(booking) ?? 0;
    return (
      <Space direction="vertical" size={0}>
        <span>{label}</span>
        <Tag color="blue" style={{ margin: 0, fontSize: 11 }}>
          In {days}d
        </Tag>
      </Space>
    );
  }

  return <span>{label}</span>;
};
